import React from 'react';
import { SiSoundcloud, SiBandcamp, SiBluesky, SiYoutube, SiKofi } from '@icons-pack/react-simple-icons';
import './SocialLinks.css';

const SocialLinks = () => {
    const links = [
        { href: "https://avizura.bandcamp.com/", icon: <SiBandcamp color='#FFFFFF' size={24} />, label: "Bandcamp" },
        { href: "https://ko-fi.com/avizura", icon: <SiKofi color='#FFFFFF' size={24} />, label: "Ko-fi" },
        { href: "https://avizura.bsky.social", icon: <SiBluesky color='#FFFFFF' size={24} />, label: "Bluesky" },
        { href: "https://soundcloud.com/avizura", icon: <SiSoundcloud color='#FFFFFF' size={24} />, label: "SoundCloud" },
        { href: "https://www.youtube.com/@AvizuraDnB", icon: <SiYoutube color='#FFFFFF' size={24} />, label: "YouTube" },
    ];

    return (
        <div className="container">
            {links.map((link, index) => (
                <a
                    key={index}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link"
                    aria-label={link.label}
                >
                    {link.icon}
                </a>
            ))}
        </div>
    );
};

export default SocialLinks;